<template>
    <persistent-banner
        v-if="show"
        background-color="var(--palette-blue-10)"
        text-color="var(--palette-gray-100)">
        <pendo-icon
            class="install-banner__icon"
            type="alert-circle"
            :size="24" />
        <span class="install-banner__content">
            Looks like you haven’t installed the Pendo Snippet yet. Once it’s installed, you’ll see your product data
            and be able to use Pendo.
        </span>
        <pendo-button
            class="install-banner__button"
            theme="app"
            type="primary"
            label="Here’s how to install it"
            size="mini"
            @click="goToSetup" />
    </persistent-banner>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { PendoButton, PendoIcon } from '@pendo/components';
import PersistentBanner from '../../common/persistent-banner/persistent-banner.vue';
import get from 'lodash/get';

export default {
    name: 'InstallSnippetBanner',
    components: {
        PersistentBanner,
        PendoButton,
        PendoIcon,
    },
    computed: {
        ...mapState({
            subscription: (state) => state.subscription.active,
        }),
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
            productLineByType: 'productLines/productLineByType',
            isInTrial: 'subscription/isInTrial',
        }),
        show () {
            if (this.isInTrial) return false;
            if (this.$route && this.$route.name === 'OnboardingHomepage') return false;
            if (!this.isAuthenticated) return false;
            if (this.feedbackOnly) return false;

            return !this.subscription.eventCount;
        },
        feedbackOnly () {
            const feedbackProductLine = this.productLineByType('feedback');
            const coreProductLine = this.productLineByType('core');

            const feedbackPurchased = get(feedbackProductLine, 'purchased', false);
            const corePurchased = get(coreProductLine, 'purchased', false);

            return feedbackPurchased && !corePurchased;
        },
    },
    methods: {
        goToSetup () {
            window.location.assign(`/setup?setupKey=${this.subscription.setupKey}`);
        },
    },
};
</script>

<style scoped lang="less">
.install-banner__icon {
    margin-right: 16px;
}
.install-banner__content {
    text-align: center;
}
.install-banner__button {
    margin-left: 16px;
    font-size: 12px;
    font-weight: 400;
}
</style>
